import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { APP_BASE_HREF } from '@angular/common';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

async function bootstrap() {
  // Providers extra para el injector raíz. Vacío = Angular usa el <base href>
  // real del DOM para el Router (correcto en los builds por-sitio, ej.
  // "venturaplaza", que ya compilan con baseHref="/venturaplaza/").
  const extraProviders: any[] = [];

  if ((environment as any).multiSite) {
    try {
      const folder = location.pathname.split('/').filter(Boolean)[0] || '';
      // El build "multiSite" compila con <base href="/"> (para que los
      // .js/.css/assets se resuelvan siempre desde la raíz de nginx, sin
      // importar qué tan profunda sea la ruta visitada). Pero el Router de
      // Angular usa ESE MISMO <base href> para saber qué prefijo recortar de
      // la URL al hacer match de rutas — con "/" no recorta nada y termina
      // buscando una ruta literal "venturaplaza" (NG04002). Por eso se le
      // inyecta el prefijo real del sitio aparte, vía APP_BASE_HREF, sin
      // tocar el <base href> del DOM (que debe seguir en "/" para los assets).
      extraProviders.push({ provide: APP_BASE_HREF, useValue: folder ? `/${folder}/` : '/' });

      // cache: 'no-store' — sin esto el navegador puede servir una copia cacheada del
      // registro y no ver ediciones recientes (p.ej. un imageIcon nuevo) hasta un hard-refresh.
      const registry = await fetch('./assets/centros-comerciales.json', { cache: 'no-store' }).then(res => res.json());
      const siteConfig = registry[folder];
      if (siteConfig) {
        Object.assign(environment, siteConfig);
      } else {
        console.error(`No se encontró configuración para el sitio "${folder}" en centros-comerciales.json`);
      }
    } catch (err) {
      console.error('Error cargando la configuración del centro comercial', err);
    }
  }
  return platformBrowserDynamic(extraProviders).bootstrapModule(AppModule);
}

bootstrap().catch(err => console.error(err));
